var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 7,
    viewBox: "0 0 26 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7529 3.16235V6.99992H20.9943V4.72581H23.5345C24.6037 4.71825 25.5118 4.06865 25.8543 3.16235H18.7529Z",
    fill: "#37A72E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4541 0C18.5847 1.56858 20.1448 2.80711 22.0501 2.80711C22.0564 2.80711 25.9474 2.80711 25.9474 2.80711C25.9762 2.66325 25.9912 2.51477 25.9912 2.36294C25.9912 1.06357 24.8891 0.00961254 23.5257 6.53784e-05L18.4541 0Z",
    fill: "url(#paint0_linear_1998_11944)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1367 2.76978L15.1385 2.7662L15.1387 2.76625C15.1617 2.72704 15.2057 2.70051 15.2563 2.70051C15.3293 2.70051 15.3887 2.75586 15.3907 2.82486L15.3908 2.82487V6.96447H17.6321V0H15.3908C15.1065 0.00899878 14.7854 0.207391 14.666 0.450923L12.8823 4.08939C12.8779 4.10426 12.871 4.11815 12.8621 4.13061L12.8615 4.13183L12.8613 4.13176C12.8343 4.1687 12.7893 4.19289 12.7385 4.19289C12.6559 4.19289 12.589 4.12926 12.589 4.05076V0H10.3477V6.96447H12.589V6.96367C12.8702 6.94971 13.1837 6.75355 13.3014 6.51354L15.1321 2.77916C15.1335 2.77597 15.1351 2.77284 15.1367 2.76978Z",
    fill: "#37A72E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76722 2.88883L5.45723 6.96447H3.84483L2.53405 2.88635C2.52141 2.82105 2.46125 2.77157 2.38894 2.77157C2.30744 2.77157 2.24138 2.83441 2.24138 2.91193C2.24138 2.91252 2.24138 2.91311 2.24139 2.9137L2.24138 6.96447H0V0H1.92385H2.49681C2.90923 0 3.34142 0.30444 3.46194 0.679401L4.55276 4.07317C4.60703 4.24203 4.69509 4.24185 4.7493 4.07317L5.84013 0.679401C5.96073 0.304178 6.39278 0 6.80525 0L7.37804 0H9.30172V6.96447H7.06034V2.91371C7.06034 2.91311 7.06034 2.91252 7.06034 2.91193C7.06034 2.83441 6.99428 2.77157 6.91279 2.77157C6.83957 2.77157 6.7788 2.8223 6.76722 2.88883Z",
    fill: "#37A72E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1998_11944",
    x1: 18.4541,
    y1: 1.40355,
    x2: 25.9912,
    y2: 1.40355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.bb76653788e24391d538c9117703a9a2.svg";
export { ForwardRef as ReactComponent };